import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

type supplementOrderInitialStateType = {
  existingAddons: any;
  allServices: any;
  cartServices : any;
  deleteProducts : any;
  addProducts:any;
  existingStandardPlans: any;
};
const initialState: supplementOrderInitialStateType = {
  existingAddons: null,
  allServices: null,
  cartServices: null,
  deleteProducts:null,
  addProducts:null,
  existingStandardPlans: null,
};

const supplementOrder = createSlice({
  name: "supplement/Services",
  initialState,
  reducers: {
    clearSupplementOrder: (state) => {
      return initialState;
    },
    setExistingAddons: (state, action: PayloadAction<any>) => {
      state.existingAddons = action.payload;
    },
    setAllServices: (state, action: PayloadAction<any>) => {
      state.allServices = action.payload;
    },
    setCartServices: (state, action: PayloadAction<any>) => {
      state.cartServices = action.payload;
    },
    setDeletedServices: (state, action: PayloadAction<any>) => {
      state.deleteProducts = action.payload;
    },
    setAddedServices: (state, action: PayloadAction<any>) => {
      state.addProducts = action.payload;
    },
    setExistingStandardPlans: (state, action: PayloadAction<any>) => {
      state.existingStandardPlans = action.payload;
    },
  },
   extraReducers: (builder) => {    
      builder.addCase(PURGE, () => {
        return initialState;
      })
    },
});

export const {
  setExistingAddons,
  clearSupplementOrder,
  setCartServices,
  setDeletedServices,
  setAddedServices,
  setExistingStandardPlans,
} = supplementOrder.actions;
export default supplementOrder.reducer;